import {
    ADMINADDLANGUAGE_SUCCESS,
    ADMINADDLANGUAGE_FAILED,
    RESET_ADMINADDLANGUAGE,
    LOADING_ADMINADDLANGUAGE,
    NETWORK_ERROR_ADMINADDLANGUAGE
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminAddLanguage = () => {
    return { type: RESET_ADMINADDLANGUAGE };
};

const AdminAddLanguages = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINADDLANGUAGE });
    await adminServices
        .post("addLanguage", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminAddLanguagesuccess(res.data));
                    break;
                default:
                    dispatch(AdminAddLanguageFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINADDLANGUAGE,
                payload: err
            });
        });
};


function AdminAddLanguagesuccess(data) {
    return {
        type: ADMINADDLANGUAGE_SUCCESS,
        payload: data
    };
}
function AdminAddLanguageFailed(data) {
    return {
        type: ADMINADDLANGUAGE_FAILED,
        payload: data
    };
}

export { AdminAddLanguages, resetAdminAddLanguage }